import { useEffect, useRef } from "react";
import { Star, X, ImagePlus } from "lucide-react";

const TYPES = ["image/jpeg", "image/png", "image/webp"];

// ID-069: photos stay in the browser until the design is created; the first photo is the primary one
export const DesignPhotos = ({ photos, setPhotos }) => {
  const input = useRef(null);
  useEffect(() => () => { photos.forEach((p) => URL.revokeObjectURL(p.url)); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const add = (files) => {
    const ok = [...files].filter((f) => TYPES.includes(f.type) && f.size <= 10 * 1024 * 1024);
    setPhotos((p) => [...p, ...ok.map((file) => ({ id: `${file.name}-${file.size}-${Math.random()}`, file, url: URL.createObjectURL(file) }))]);
  };
  const remove = (id) => setPhotos((p) => p.filter((x) => { if (x.id === id) URL.revokeObjectURL(x.url); return x.id !== id; }));
  const primary = (id) => setPhotos((p) => [...p.filter((x) => x.id === id), ...p.filter((x) => x.id !== id)]);
  return (
    <div className="space-y-2" data-testid="design-photos">
      <input ref={input} type="file" accept={TYPES.join(",")} multiple className="hidden" data-testid="design-photos-input"
        onChange={(e) => { add(e.target.files); e.target.value = ""; }} />
      <div className="flex flex-wrap gap-2">
        {photos.map((p, i) => (
          <div key={p.id} className={`relative h-24 w-24 overflow-hidden rounded-md border-2 ${i === 0 ? "border-terracotta" : "border-border"}`} data-testid={`design-photo-${i}`}>
            <img src={p.url} alt={p.file.name} className="h-full w-full object-cover" />
            {i === 0 ? <span className="absolute bottom-0 left-0 right-0 bg-terracotta py-0.5 text-center text-[10px] font-semibold text-white" data-testid={`design-photo-${i}-primary`}>Primary</span>
              : <button type="button" onClick={() => primary(p.id)} className="absolute bottom-1 left-1 rounded bg-white/90 p-1" aria-label="Make primary" data-testid={`design-photo-${i}-make-primary`}><Star className="h-3 w-3" /></button>}
            <button type="button" onClick={() => remove(p.id)} className="absolute right-1 top-1 rounded bg-white/90 p-1" aria-label="Remove photo" data-testid={`design-photo-${i}-remove`}><X className="h-3 w-3" /></button>
          </div>
        ))}
        <button type="button" onClick={() => input.current?.click()} className="flex h-24 w-24 flex-col items-center justify-center gap-1 rounded-md border border-dashed border-border text-xs text-warmgrey hover:border-terracotta" data-testid="design-photos-add">
          <ImagePlus className="h-5 w-5" />Add photos
        </button>
      </div>
      <p className="text-xs text-warmgrey">JPG, PNG or WebP up to 10 MB each. Saved to the collection only after the design is created.</p>
    </div>
  );
};
